export default "__VITE_ASSET__smh9JKcA__"